import React from 'react'
import { PropsWithChildren } from 'react'
import { Routes, Route } from 'react-router-dom'
import Redirect from '../Redirect/Redirect'
import Thanx from '../Thanx/Thanx'
import Welcome from '../Welcome'
import Progress from '../Wizard/Progress/Progress'

const AppRouting: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
    return (
        <Routes>
            <Route
                path='/'
                element={<Welcome />}
            ></Route>
            <Route
                path='/wizard'
                element={<Progress />}
            ></Route>
            <Route
                path='/thanks'
                element={<Thanx />}
            ></Route>
            <Route
                path='/redirect'
                element={<Redirect />}
            ></Route>
        </Routes>
    )
}
export default AppRouting
